module.exports = new __parcel__URL__("favicon.fa33a39a.png").toString();